import { createAsyncThunk } from '@reduxjs/toolkit';
import { SuggestedFaqAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import {
  IApproveSuggestedFaqDTO,
  IRejectSuggestedFaqDTO,
  ISuggestedFaqDetails,
  IGetSuggestedFaqByIdDTO,
  IApproveSuggestedFaqResponse,
} from '@/models/suggestedFaq.model';
import { SLICE_NAME } from './models';

export const getSuggestedFaqById = createAsyncThunk<
  ISuggestedFaqDetails,
  IGetSuggestedFaqByIdDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getSuggestedFaqById`,
  async (params) => {
    const response = await SuggestedFaqAPI.getSuggestedFaqById(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const approveSuggestedFaq = createAsyncThunk<
  IApproveSuggestedFaqResponse,
  IApproveSuggestedFaqDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/approveSuggestedFaq`,
  async (data) => {
    const response = await SuggestedFaqAPI.approveSuggestedFaq(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const rejectSuggestedFaq = createAsyncThunk<
  ISuggestedFaqDetails,
  IRejectSuggestedFaqDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/rejectSuggestedFaq`,
  async (data) => {
    const response = await SuggestedFaqAPI.rejectSuggestedFaq(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
